import { useState } from "react";
import createMuiTheme, { Theme } from "@material-ui/core/styles/createMuiTheme";
import { lighten } from "@material-ui/core";
import responsiveFontSizes from "@material-ui/core/styles/responsiveFontSizes";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import useTheme from "@material-ui/core/styles/useTheme";

export default (): [boolean, Function, Theme] => {
  const [darkTheme, toggleTheme] = useState<boolean>(false);
  const defaultTheme = useTheme();
  const isDesktop = useMediaQuery(defaultTheme.breakpoints.up("lg"));

  const noTransitions = () => {
    if (isDesktop) {
      return {};
    } else {
      return {
        transitions: {
          create: () => "none",
        },
      };
    }
  };

  const theme = createMuiTheme({
    palette: {
      type: darkTheme ? "dark" : "light",
      primary: {
        main: darkTheme ? "#dddddd" : "#cf5023",
        light: darkTheme ? lighten("#ddd", 0.2) : "#cf5023",
      },
      secondary: { main: "#10111e" },
      error: { main: "#d9534f" },
      info: { main: "#3db0e2" },
    },
    ...noTransitions(),
  });
  return [darkTheme, toggleTheme, responsiveFontSizes(theme)];
};
